function past_Reducer(state = [], action) {
    switch (action.type) {
        case 'PAST/SET':
            return action.past;
        case 'PAST/CLEAR':
            return null;
        default:
            return state;
    }
}

export default past_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/past.js